import moment from 'moment'
import _ from 'lodash'
function dev(msg){
    // alert(msg)
    // console.log(msg)
}
function dump(...args){
    // console.log(...args)
}

// ----------------------------------------
// ApplyCoupon用データroomData生成実装群 ここから
// ----------------------------------------
// UIから入力された各種情報（publicStayInfo）から、
// ApplyCouponコンポーネントで必要な情報を生成する
// 
export function generateRoomDetailsForApplyCoupon(publicStayInfo) {
    dump('generateRoomDetailsForApplyCoupon UI情報', publicStayInfo)
    const stayRoomDetails = []
    for (let i = 0; i< publicStayInfo.peopleRoom.length; i++) {
        // データ源泉のpublicStayInfo.peopleRoomは、
        // ApplyCouponに必要なDataDetailsに酷似してるので、
        // そのまま流用しつつ、差分を再計算して設定する。
        const roomData = _.cloneDeep(publicStayInfo.peopleRoom[i]) 
        dump('before roomData', roomData)
        roomData.roomNo = i + 1

        roomData.stayDays = []
        roomData.relationships = roomData.relationships || []
        for (let i = 0; i < publicStayInfo.stayDateRoom.stayNight; i++) {
            roomData.stayDays.push({'stayDay':moment(publicStayInfo.stayDateRoom.date).add(i, 'days').format('YYYY/MM/DD')})
            // relationshipsにstayDayを格納し、連泊のときでも正しく適用するよう修正
            for (let j = 0; j < roomData.relationships.lenght; i++) {
                roomData.relationships[j].push({'stayDay':moment(publicStayInfo.stayDateRoom.date).add(i, 'days').format('YYYY/MM/DD')})
            }
        }
        // roomData.member.man = 0 // そのまま利用できる
        // roomData.visitors.man = 0 // そのまま利用できる
        roomData.chldaManHeadCnt = countAllChildren(roomData)
        roomData.chldaWomanHeadCnt = countAllVisitorChildren(roomData)

        roomData.adultCount = +roomData.member?.man + roomData.visitors?.man
        roomData.childrenCount = roomData.chldaManHeadCnt + roomData.chldaWomanHeadCnt
        roomData.roomAmount = calcRoomAmount(roomData)

        roomData.memberChildren = extractChildren(roomData)
        roomData.visitorChildren = extractVisitorChildren(roomData)

        roomData.vacancyCalendar = generateVacancyCalendarForApplyCoupon(roomData)

        dump('after  roomData', roomData)
        stayRoomDetails.push(roomData)
    }
    dump('generateRoomDetailsForApplyCoupon 生成情報', stayRoomDetails)
    return stayRoomDetails;
}
function countAllChildren(roomData) {
    dev('countAllChildren!!')
    return (+roomData?.children?.childrenMember10 || 0)
    + (+roomData?.children?.childrenMember15 || 0)
    + (+roomData?.children?.childrenMember20 || 0)
    + (+roomData?.children?.childrenMember30 || 0)
    + (+roomData?.children?.childrenMember40 || 0)
    + (+roomData?.children?.childrenMember50 || 0)
}
function countAllVisitorChildren(roomData) {
    dev('countAllVisitorChildren!!')
    return (+roomData?.children?.childrenType10 || 0)
    + (+roomData?.children?.childrenVisitor15 || 0)
    + (+roomData?.children?.childrenVisitor20 || 0)
    + (+roomData?.children?.childrenVisitor30 || 0)
    + (+roomData?.children?.childrenVisitor40 || 0)
    + (+roomData?.children?.childrenVisitor50 || 0)
}
function calcRoomAmount(roomData) {
    dev('calcRoomAmount!!')
    // 宿泊数
    const nightCnt = roomData.stayDays.length
    // 部屋/会員/ビジターごとの合計金額を格納
    let roomAmount = 0
    let memberTotalFee = 0
    let visitorTotalFee = 0

    let childrenFee = 0
    let visitorChildrenFee = 0
    // 大人／子どもの人数と宿泊料金をかけて算出
    let memberFee = +_.get(roomData, 'member.man', 0 ) * +_.get(roomData, 'member.manPrice', 0)
    let visitorMemberFee = +_.get(roomData, 'visitors.man', 0 ) * +_.get(roomData, 'visitors.visitorManPrice', 0)
    childrenFee += +_.get(roomData, 'children.childrenMember10', 0) * +_.get(roomData, 'children.childrenMember10Price', 0)
    childrenFee += +_.get(roomData, 'children.childrenMember15', 0) * +_.get(roomData, 'children.childrenMember15Price', 0)
    childrenFee += +_.get(roomData, 'children.childrenMember20', 0) * +_.get(roomData, 'children.childrenMember20Price', 0)
    childrenFee += +_.get(roomData, 'children.childrenMember30', 0) * +_.get(roomData, 'children.childrenMember30Price', 0)
    childrenFee += +_.get(roomData, 'children.childrenMember40', 0) * +_.get(roomData, 'children.childrenMember40Price', 0)
    childrenFee += +_.get(roomData, 'children.childrenMember50', 0) * +_.get(roomData, 'children.childrenMember50Price', 0)
    visitorChildrenFee += +_.get(roomData, 'children.childrenVisitor10', 0) * +_.get(roomData, 'children.childrenVisitor10Price', 0)
    visitorChildrenFee += +_.get(roomData, 'children.childrenVisitor15', 0) * +_.get(roomData, 'children.childrenVisitor15Price', 0)
    visitorChildrenFee += +_.get(roomData, 'children.childrenVisitor20', 0) * +_.get(roomData, 'children.childrenVisitor20Price', 0)
    visitorChildrenFee += +_.get(roomData, 'children.childrenVisitor30', 0) * +_.get(roomData, 'children.childrenVisitor30Price', 0)
    visitorChildrenFee += +_.get(roomData, 'children.childrenVisitor40', 0) * +_.get(roomData, 'children.childrenVisitor40Price', 0)
    visitorChildrenFee += +_.get(roomData, 'children.childrenVisitor50', 0) * +_.get(roomData, 'children.childrenVisitor50Price', 0)
    // 会員とビジターの各合計金額を算出
    memberTotalFee += memberFee + childrenFee
    visitorTotalFee += visitorMemberFee + visitorChildrenFee

    // 部屋ごとの各合計金額に宿泊数をかける
    // roomAmountは利用可能チェックAPI(/v2/sbsd/reservation)で使用されるため、部屋ごとの合計金額を算出する必要がある
    roomAmount = (memberTotalFee + visitorTotalFee) * nightCnt
    return roomAmount
}
function extractChildren(roomData) {
    dump('extractChildren!!',roomData)
    const children = {
    childrenType10: roomData.children?.childrenMember10 || 0,
    childrenType15: roomData.children?.childrenMember15 || 0,
    childrenType20: roomData.children?.childrenMember20 || 0,
    childrenType30: roomData.children?.childrenMember30 || 0,
    childrenType40: roomData.children?.childrenMember40 || 0,
    childrenType50: roomData.children?.childrenMember50 || 0,
    }
    dump('extractChildren!!',children)
    return children
}
function extractVisitorChildren(roomData) {
    dev('extractVisitorChildren!!')
    const children = {
    childrenType10: roomData.children?.childrenVisitor10 || 0,
    childrenType15: roomData.children?.childrenVisitor15 || 0,
    childrenType20: roomData.children?.childrenVisitor20 || 0,
    childrenType30: roomData.children?.childrenVisitor30 || 0,
    childrenType40: roomData.children?.childrenVisitor40 || 0,
    childrenType50: roomData.children?.childrenVisitor50 || 0,
    }
    return children
}
// ----------------------------------------
// ApplyCoupon用データroomData生成実装群 ここまで
// ----------------------------------------


// ----------------------------------------
// ApplyCoupon用データvacancyCalendar生成実装群 ここから
// ----------------------------------------
// 前工程でUIから入力された各種情報（publicStayInfo）から、
// ApplyCouponコンポーネントで必要な情報を生成する
function generateVacancyCalendarForApplyCoupon(roomData) {
    dev('generateVacancyCalendarForApplyCoupon!! TODO: 要検討')
    const resultVacancyCalendar = {
        "priceRemarks": null,
        "stayTaxInfo": [],
        "childPriceInfo": genChildPriceInfo(roomData),
        "vacancyCalendars": genVacancyCalendars(roomData),
    }
    return resultVacancyCalendar;
}
// 下記の構造を作成する
// 公共の宿は、vacancyCalendarが無いため、
// UIで入力された情報で作成する
// childPriceInfo: {
//    "childFeeApplicationDiv": "1",
//    "childInfos": [
//        {
//            "priceUnit": "％",
//            "priceReference": "大人料金に対して100%",
//            "subsidySettDiv": "",
//            "subsidy": null,
//            "price": 100,
//            "calc": "1",
//            "childDiv": "10",
//            "transFeeFlag": 1,
//            "content": null
//        },
//    ]
// },
function genChildPriceInfo(roomData) {
    dev('genChildPriceInfo!! ')
    dump('genChildPriceInfo', roomData)
    const resultChildPriceInfo = {
    childFeeApplicationDiv: '1',
    childInfos: genChildInfos(roomData)
    }
    return resultChildPriceInfo;
}
function genChildInfos(roomData) {
    dev('genChildInfos!! ')
    dump('genChildInfos', roomData)
    const resultChildInfos = []

    return resultChildInfos;
}
// 下記の構造を作成する
// 公共の宿は、vacancyCalendarが無いため、
// UIで入力された情報で作成する
//"vacancyCalendars": [
//    {
//        "roomPrice": null,
//        "price": 9600,
//        "adultPrice": 9600,
//        "stayDay": "2022/06/22",
//        "boneSubsidy": 0,
//        "childrenPriceTable": [
//            {
//                "childDiv": "10",
//                "childPrice": 9600,
//                "price": 9600,
//                "boneSubsidy": 0
//            },
//            {
//                "childDiv": "15",
//                "childPrice": 9600,
//                "price": 9600,
//                "boneSubsidy": 0
//            }
//        ],
//        "reservationDiv": "10",
//        "stock": 30
//    }
//]
function genVacancyCalendars(roomData){
    dev('genVacancyCalendars!! ')
    dump('genVacancyCalendars roomData', roomData)
    // 部屋別の大人と子どもの金額を設定する
    // 滞在日数分作成して配列に格納する
    // 在庫は99として作成する
    // 部屋金額は、UIで人別に入力されるため、0設定する
    // 上位階層で宿泊日情報は設定済み前提、
    // 宿泊日数分、vacancyCalendarを作成する
    const resultVacancyCalendars = [];
    roomData.stayDays.forEach(element => {
        dump('stayday', element.stayDay);
        const resultVacancyCalendar = {
            roomPrice: 0, //部屋料金は無いので0設定
            price: calcPriceByDay(roomData), // 会員料金
            adultPrice: calcAdultPriceByDay(roomData), // 非会員料金
            stayDay: element.stayDay,
            boneSubsidy: 0,
            childrenPriceTable: genChildrenPriceTable(roomData),
            reservationDiv: '10',
            stock: 99
        }
        resultVacancyCalendars.push(resultVacancyCalendar);
    });
    dump('genVacancyCalendars resultVacancyCalendars', resultVacancyCalendars)
    return resultVacancyCalendars;
}
function calcPriceByDay(roomData) {
    dev('calcPriceByDay!! ')
    dump('calcPriceByDay', roomData)
    const resultPrice = roomData.member?.manPrice || 0;
    // 1泊の会員料金を計算する
    dump('calcPriceByDay resultPrice', resultPrice)
    return resultPrice;
}
function calcAdultPriceByDay(roomData) {
    dev('calcAdultPriceByDay!! ')
    dump('calcAdultPriceByDay', roomData)
    const resultPrice = roomData.visitors?.visitorManPrice || 0;
    // 1泊の非会員料金を計算する
    dump('calcAdultPriceByDay resultPrice', resultPrice)
    return resultPrice;
}
// 子供金額テーブルを作成する
function genChildrenPriceTable(roomData) {
    dev('genChildrenPriceTable!! ')
    dump('genChildrenPriceTable', roomData)
    const resultChildrenPriceTable = []
    // 1泊の子供金額テーブルを作成する
    const childPriceRow10 = {
    childDiv: '10',
    childPrice: roomData.children?.childrenVisitor10Price || 0, // 非会員料金
    price: roomData.children?.childrenMember10Price || 0, // 会員料金
    boneSubsidy: 0
    }
    resultChildrenPriceTable.push(childPriceRow10)
    const childPriceRow15 = {
    childDiv: '15',
    childPrice: roomData.children?.childrenVisitor15Price || 0, // 非会員料金
    price: roomData.children?.childrenMember15Price || 0, // 会員料金
    boneSubsidy: 0
    }
    resultChildrenPriceTable.push(childPriceRow15)
    const childPriceRow20 = {
    childDiv: '20',
    childPrice: roomData.children?.childrenVisitor20Price || 0, // 非会員料金
    price: roomData.children?.childrenMember20Price || 0, // 会員料金
    boneSubsidy: 0
    }
    resultChildrenPriceTable.push(childPriceRow20)
    const childPriceRow30 = {
    childDiv: '30',
    childPrice: roomData.children?.childrenVisitor30Price || 0, // 非会員料金
    price: roomData.children?.childrenMember30Price || 0, // 会員料金
    boneSubsidy: 0
    }
    resultChildrenPriceTable.push(childPriceRow30)
    const childPriceRow40 = {
    childDiv: '40',
    childPrice: roomData.children?.childrenVisitor40Price || 0, // 非会員料金
    price: roomData.children?.childrenMember40Price || 0, // 会員料金
    boneSubsidy: 0
    }
    resultChildrenPriceTable.push(childPriceRow40)
    const childPriceRow50 = {
    childDiv: '50',
    childPrice: roomData.children?.childrenVisitor50Price || 0, // 非会員料金
    price: roomData.children?.childrenMember50Price || 0, // 会員料金
    boneSubsidy: 0
    }
    resultChildrenPriceTable.push(childPriceRow50)

    dump('genChildrenPriceTable resultChildrenPriceTable', resultChildrenPriceTable)
    return resultChildrenPriceTable;
}

// ----------------------------------------
// ApplyCoupon用データvacancyCalendar生成実装群 ここまで
// ----------------------------------------

export function customPlanToSelectedSubsidyList(couponPlanData) {
  dump("customPlanToSelectedSubsidyList customPlanData", couponPlanData)
  // 必要なデータ
  // 補助金名 customPlanData.styaNightDetails[i].coupons[j].availableData.dispSubsidyNm
  // 補助金金額 customPlanData.styaNightDetails[i].coupons[j].availableData.PriceList[k].price
  // 補助金金額 customPlanData.styaNightDetails[i].coupons[j].availableData.PriceList[k].priceLabel
  // 利用枚数 customPlanData.styaNightDetails[i].coupons[j].availableData.PriceList[k].selectUseCnt
  // 補助金ID customPlanData.styaNightDetails[i].coupons[j].availableData.PriceList[k].subsidyPriceId
  // 補助金サブID customPlanData.styaNightDetails[i].coupons[j].availableData.PriceList[k].subsidyDetailId
  const selectedSubsidyList = [];
  const stayNightDetails = couponPlanData?.stayNightDetails;
  if (!stayNightDetails) {
    return selectedSubsidyList;
  }
  for(let i = 0; i < stayNightDetails.length; i++) {
    const subsidyDatabyStayNight = {
      subsidyList: []
    }

    // 部屋ごとにループをまわす
    stayNightDetails[i].rooms.forEach((room) => {
      room.relationships.forEach((rela) => {
        rela.appliedCoupons.forEach((appliedCoupon) => {
          // 続柄ごとに適用した補助金リストをセット
          const relaAppliedCouponsList = {
            subsidyId: appliedCoupon.availableData.subsidyId,
            dispSubsidyNm: appliedCoupon.availableData.dispSubsidyNm,
            priceList: [appliedCoupon.applyPrice]
          }
          subsidyDatabyStayNight.subsidyList.push(relaAppliedCouponsList);
        })
      })
    })
    // 補助金ごとの補助申請額を計算するためのリストにセット
    selectedSubsidyList.push(subsidyDatabyStayNight);
  }
  dump("customPlanToSelectedSubsidyList selectedSubsidyList", selectedSubsidyList)
  return selectedSubsidyList;
}